import React, { useEffect , useRef, useState} from 'react';
import PropTypes from "prop-types";

//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import RightSidebar from '../Components/Common/bootstrap/RightSidebar';
import Loading from "Components/Common/Loading";
import CreamChatbot from 'Components/CreamChatbot';

//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from "../store/actions";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from '../Components/Common/bootstrap/withRouter';
import SimpleBar from 'simplebar-react';
import { useLocation } from 'react-router-dom';
import { CpmAuth } from 'script/cpmAuth';

const Layout = (props) => {
    const location = useLocation();
    const {loading} = useSelector(state => state.Loading)
    const [headerClass, setHeaderClass] = useState("");
    const dispatch = useDispatch();
    const scrollRef = useRef();
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype
    } = useSelector(state => ({
        layoutType: state.Layout.layoutType,
        leftSidebarType: state.Layout.leftSidebarType,
        layoutModeType: state.Layout.layoutModeType,
        layoutWidthType: state.Layout.layoutWidthType,
        layoutPositionType: state.Layout.layoutPositionType,
        topbarThemeType: state.Layout.topbarThemeType,
        leftsidbarSizeType: state.Layout.leftsidbarSizeType,
        leftSidebarViewType: state.Layout.leftSidebarViewType,
        leftSidebarImageType: state.Layout.leftSidebarImageType,
        sidebarVisibilitytype: state.Layout.sidebarVisibilitytype,
    }));

    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch]);

    // 헤더
    useEffect(() => {
        if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
            document.querySelector(".hamburger-icon").classList.remove('open');
        } else {
            document.querySelector(".hamburger-icon").classList.add('open');
        }
    }, [sidebarVisibilitytype, layoutType]);

    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };


    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    // 스크롤 상단으로 이동 
    window.scrollToTop = () => {
        const scrollEl = scrollRef.current.getScrollElement()
        scrollEl.scrollTop = 0;
    }

    // 페이지가 이동하면 스크롤 상단으로 이동
    useEffect(() => {
        window.scrollToTop();
    }, [props.children])

    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });

    return (
        <React.Fragment>
            <CpmAuth/>
            <div id="layout-wrapper">
                {/* 헤더 */}
                <SimpleBar ref={scrollRef} style={{ maxHeight: "100vh" }} className="main-content">
                <Header
                    headerClass={headerClass}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode} />
                    {props.children}
                </SimpleBar>
                <Sidebar
                    layoutType={layoutType}
                />
            </div>
            {location.pathname === '/cpds0010e01' && <RightSidebar />}
            {loading && <Loading/>}
            <CreamChatbot />
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.any,
};

export default withRouter(Layout);
